import BreadcrumbListSD from 'components/common/SEO/BreadcrumbListSD'
import FacebookOGMetas from 'components/common/SEO/FacebookOGMetas'
import OrganisationSD from 'components/common/SEO/OrganisationSD'
import PersonSD from 'components/common/SEO/PersonSD'
import TwitterMarups from 'components/common/SEO/TwitterMarups'
import WebPageSD from 'components/common/SEO/WebPageSD'
import WebSiteSD from 'components/common/SEO/WebSiteSD'
import { stripHtml } from 'helpers'
import { Helmet } from 'react-helmet'
import Text from './text.json'
import { TrainerPrimaryPath } from 'navigation/Routes'

const breadcrumbList = (nameTrainer, slug) => [
  {
    link: window.location.origin,
    name: 'Accueil'
  },
  {
    link: `${window.location.origin}${TrainerPrimaryPath}/${slug}`,
    name: nameTrainer
  }
]

export default ({ firstName, lastName, description, slug, avatar, metadataTitle, metadaDescription }) => {
  const formattedDescription = stripHtml(metadaDescription || description).replace(/"/g, '\\"')
  const link = `${window.location.origin}${window.location.pathname}`
  const titleMetaDataToSet = metadataTitle || `${Text.prefixTitle} ${firstName} ${lastName} ${Text.sufixTitle}`
  return (
    <>
      <Helmet>
        <title>{titleMetaDataToSet}</title>
        <meta name='description' content={formattedDescription} />
        <link rel='canonical' href={link} />
      </Helmet>
      <FacebookOGMetas
        link={link}
        title={titleMetaDataToSet}
        description={formattedDescription}
        image={avatar}
      />
      <TwitterMarups
        link={link}
        title={titleMetaDataToSet}
        description={formattedDescription}
        image={avatar}
      />
      <OrganisationSD />
      <WebSiteSD />
      <WebPageSD
        title={titleMetaDataToSet}
        description={formattedDescription}
      />
      <BreadcrumbListSD items={breadcrumbList(`${firstName} ${lastName}`, slug)} />
      <PersonSD />
    </>
  )
}
